/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HttpswwwyourbusinesscomInputs */

const en_httpswwwyourbusinesscom = /** @type {(inputs: HttpswwwyourbusinesscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.yourbusiness.com`)
};

const de_httpswwwyourbusinesscom = /** @type {(inputs: HttpswwwyourbusinesscomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://www.yourbusiness.com`)
};

/**
* | output |
* | --- |
* | "https://www.yourbusiness.com" |
*
* @param {HttpswwwyourbusinesscomInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const httpswwwyourbusinesscom = /** @type {((inputs?: HttpswwwyourbusinesscomInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HttpswwwyourbusinesscomInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_httpswwwyourbusinesscom(inputs)
	return de_httpswwwyourbusinesscom(inputs)
});